import React, {SetStateAction, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {MdSend} from 'react-icons/md';
import {useSelector} from 'react-redux';
import {User} from '../../../../model/user/User';
import {CustomImageHandler} from '../../../../shared/components/CustomImageHandler';
import MentionInputField from '../../../../shared/components/message/MentionInputField';
import {MessageBody} from '../../../../shared/components/message/MessageBody';
import {IAllStates} from '../../../../store/rootReducer';
import {ErrorToast} from '../../../../utils/toasters';
import {iManageList} from '../../../brand/campaign/manage/calendar/dto/IManageCalendar';
import {IPlannerMessage} from '../../../influencer/planner/components/preview/PreviewFeedback';
import {InfluencerPlannerService} from '../../../influencer/planner/service';
import {AgencyPlannerService} from '../service';

interface IPreviewFeedbackProps {
    state: iManageList;
    setState: React.Dispatch<SetStateAction<iManageList>>;
    setHasTextInsideField: React.Dispatch<SetStateAction<boolean>>;
}

const initialMessageState: IPlannerMessage = {
    message: '',
    eventId: 0,
};

const AgencyPlannerChat = ({state, setState, setHasTextInsideField}: IPreviewFeedbackProps) => {
    const {t} = useTranslation();
    const {user} = useSelector((states: IAllStates) => states.auth);
    const lastMessageRef = useRef<HTMLInputElement>(null);
    const [newMessage, setNewMessage] = useState(initialMessageState);
    const [mentions, setMentions] = useState<User[]>([])

    const {comments} = state;
    useEffect(() => {
        if (!!comments?.length) {
            lastMessageRef?.current?.scrollIntoView({
                behavior: 'smooth',
            });
        }
    }, [comments?.length]);

    useEffect(() => {
        setHasTextInsideField(!!newMessage?.message?.length)
        // eslint-disable-next-line
    }, [newMessage?.message?.length]);

    const changeHandler = (name: string, value: string) => {
        setNewMessage({...newMessage, [name]: value});
    };


    const sendMessageHandler = () => {
        if (!!newMessage?.message?.length) {
            AgencyPlannerService.addPlannerComment({
                ...newMessage, eventId: state?.id, message: newMessage.message.replaceAll('\n', '</br>')
            }).then(response => {
                setNewMessage(initialMessageState);
                setState(prev => ({...prev, comments: response?.comments}));
            }).catch(error => ErrorToast(error));
        }
    };

    useEffect(() => {
        const eventId = state?.id;
        const campaignId = state?.offerItem?.offer?.campaign?.id;
        if (campaignId && eventId) {
            InfluencerPlannerService.getMentions(campaignId, {isAgency: true, eventId})
                .then(response => {
                    setMentions(response?.data)
                }).catch(err => ErrorToast(err))
        }
    }, [state?.offerItem?.offer?.campaign?.id, state?.id])

    return (
        <>
            <div className="col-12">
                <div className="border-bottom pb-1 mb-2">
                    <span className="font-weight-semi-bold">{t('influencer.planner.feedback')}</span>
                </div>
                <div style={{maxHeight: 300, overflow: 'auto', paddingRight: 10}}>
                    {!!comments?.length ? comments?.map((comment) => (
                        <MessageBody comment={comment as any} key={comment?.id} haveFiles={false}
                                     senderData={comment?.sentBy}
                                     isMyMessage={+comment?.sentBy?.id === +user?.id}/>
                    )) : <p className="text-muted">{t('influencer.planner.noComments')}</p>}
                    <div ref={lastMessageRef}/>
                </div>
            </div>
            <div className="col-12">
                <div className="border-bottom d-flex align-items-start mt-4 w-100">
                    <CustomImageHandler
                        altTag="My profile logo"
                        thumbnailPath={user?.profilePhoto?.thumbnail as string}
                        photoPath={user?.profilePhoto?.path as string}
                        classes="user-img rounded-circle"
                    />
                    <div className="w-100 ml-1 mb-3">
                        <MentionInputField value={newMessage?.message ?? ''}
                                           possibleMentions={mentions}
                                           changeMessageHandler={(e) => {
                                               changeHandler('message', e.target.value)
                                           }}
                                           sendMessage={sendMessageHandler}/>
                    </div>
                    <MdSend className="chat-input-icon ml-2 send" opacity={!!newMessage?.message?.length ? 1 : 0.5}
                            onClick={sendMessageHandler}/>
                </div>
            </div>
        </>
    );
}
export default AgencyPlannerChat;
